import { LocaleEnum } from '@systemeio/ui-frontend'
import { isSupportedLocale as isLocaleSupported } from 'configs/i18n/config'

export const isSupportedLocale = (locale?: string): locale is LocaleEnum =>
  isLocaleSupported(locale)
